import { StringHelpers } from "../../helpers/string-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { IComponent } from "../component.interface";

export class AddAnchorVwapButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement;
    private base: IChartContainer;

    private active = false;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.onClick();
        this.onEscPress();
        this.onMouseDown();
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.handleAddAnchorVwapMode();
        });
    }

    private onEscPress() {
        this.base.domEvents.onEscPress(this.id, () => {
            if (this.active) {
                this.handleAddAnchorVwapMode();
            }
        });
    }
    
    private onMouseDown() {
        this.base.domEvents.onMouseDown(this.id, (event: MouseEvent) => {
            if (!this.base.tiChartSeries || !this.base.tiChartSeries.highStockChart || !this.active || event.which != 1) {
                return;
            }

            const target = event.target as HTMLElement;
            if (target && (target.classList.contains('add-anchor-vwap-button') || (target.closest && target.closest('.add-anchor-vwap-button')))) {
                return;
            }

            const xAxis = this.base.tiChartSeries.highStockChart.xAxis[0];
            if (!xAxis) {
                return;
            }
            
            const pointer = this.base.tiChartSeries.highStockChart.pointer.normalize(event);
            const xValue = xAxis.toValue(pointer.x, true);
            
            this.handleAddAnchorVwapMode();
            this.base.chartService.requestAddAVWap(xValue);
        });
    }

    private handleAddAnchorVwapMode() {
        if (this.active) {
            this.active = false;
            this.base.body.removeClass('cursor-n-resize');
        } else {
            this.active = true;
            this.base.body.addClass('cursor-n-resize');
        }
    }
}